import {Component, Input} from '@angular/core';
import {CommonModule, DecimalPipe} from "@angular/common";

@Component({
  selector: 'analytics-percent-bar',
  templateUrl: './analytics-percent-bar.component.html',
  imports: [
    CommonModule,
    DecimalPipe
  ],
  styleUrls: ['./analytics-percent-bar.component.css']
})
export class AnalyticsPercentBarComponent {
  @Input() percent: number = 0;
  @Input() colorClass = 'bg-purple-700';
  @Input() classes: string = '';
  @Input() mouseOver: boolean = false;

}
